import { render, staticRenderFns } from "./PurchaseListTableData.vue?vue&type=template&id=61d7e962&"
import script from "./PurchaseListTableData.vue?vue&type=script&lang=js&"
export * from "./PurchaseListTableData.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseListTableData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports